import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'
import { PTO_URL } from '../const'

export * from './estimate'
export * from './pto'
export * from './change'
export * from './document'
export * from './statement'

export const PTO_PROJECT_URL = `${PTO_URL}/project`

const errors = createBaseResponseErrors('проект', 'проектов')

export const PTOProjectApi = createBaseCRUDApi(PTO_PROJECT_URL, errors)
